module.exports = __webpack_public_path__ + "static/media/Belgium.f42bf9af.png";